import { Fragment, memo } from "react";

import { ApplyPriceText } from "../../../components";

/**
 * @todo QueryData から取得する
 */
type Option = {
	name: string;
	amount: number;
	price: number;
	hostInsertedPrice?: number | null | undefined;
	discountedPrice?: number | null | undefined;
};

type Props = {
	options: Array<Option>;
};

export const OptionListOfRoomWithOptionCompositions = memo(({ options }: Props) => {
	return (
		<>
			{options.map((option, index) => {
				const { name, amount, price, hostInsertedPrice, discountedPrice } = option;
				const amountText = `${amount}個`;

				return (
					<Fragment key={index}>
						{/* プラン名 */}
						<p>{name}</p>

						{/* 個数 */}
						<p className="text-xs">{amountText}</p>

						{/* 金額 */}
						<ApplyPriceText
							hostInsertedPrice={hostInsertedPrice ?? undefined}
							discountedPrice={discountedPrice ?? undefined}
							price={price}
						/>
					</Fragment>
				);
			})}
		</>
	);
});
